module.exports = __webpack_public_path__ + "static/img/fltw.348ae48.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/fltw.webp
// module id = hzpy
// module chunks = 68